import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

const WHATSAPP_URL = "https://wa.me/971551088212";

const WhatsAppButton = () => {
  const [hovered, setHovered] = useState(false);
  const location = useLocation();

  // Hide on admin routes
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 left-6 z-50 flex items-center gap-2 rounded-full shadow-lg transition-all duration-300 hover:shadow-xl"
      style={{ backgroundColor: "hsl(142, 70%, 45%)" }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className="flex items-center justify-center w-14 h-14 rounded-full">
        <MessageCircle className="w-6 h-6 text-white" fill="white" strokeWidth={0} />
      </span>
      {hovered && (
        <span className="pr-5 text-white text-sm font-body font-medium whitespace-nowrap">
          Chat with us
        </span>
      )}
    </a>
  );
};

export default WhatsAppButton;
